import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHeader } from '../../components/layout/PageHeader';
import { TutorAnalyticsPanel } from '../../components/ai-tutor/analytics/TutorAnalyticsPanel';

export const TutorAnalyticsPage: React.FC = () => (
  <Layout>
    <PageHeader title="Tutor Analytics" subtitle="Your speaking progress" />
    <TutorAnalyticsPanel />
  </Layout>
);